export const isEmailValid = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

// 8 characters, 1 uppercase, 1 lowercase, 1 number, 1 special character.
export const isPasswordValid = (password: string): boolean => {
  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&;])[A-Za-z\d@$!%*?&;]{8,}$/;
  return passwordRegex.test(password);
};

export const validateConfirmationCode = (code: string): string | undefined => {
  if (code.length !== 6) {
    return "Confirmation code must be 6 characters long.";
  }
};
